import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import {
  CircularProgress,
  Box,
  IconButton,
  Badge,
  Collapse,
  List,
  ListItemIcon,
  ListItemText,
  ListItem,
  ListItemButton,
  ListSubheader,
  Fab
} from "@mui/material";
import FeedIcon from '@mui/icons-material/Feed';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import {
  MdOutlineMailOutline,
  MdNotificationsNone,
  MdExpandMore,
  MdFolder,
  MdExpandLess,
  MdHome,
  MdSupportAgent,
} from "react-icons/md";
import { BiBookHeart } from "react-icons/bi";
import { FaChevronDown } from "react-icons/fa";
import * as API from "../api";
import { useStyles } from "./Styles";
import { PatientData } from "../Contexts";

const propTypes = {
  handleDrawerToggle: PropTypes.func.isRequired,
  notifications: PropTypes.array.isRequired,
  support_messages: PropTypes.array.isRequired,
  messages: PropTypes.array.isRequired,
  old: PropTypes.array.isRequired,
  completed_cprs: PropTypes.array.isRequired,
  cprs: PropTypes.array.isRequired,
  completed: PropTypes.object.isRequired,
  in_progress: PropTypes.object.isRequired,
  dispatch: PropTypes.func,
  window: PropTypes.func,
  children: PropTypes.object.isRequired,
};
Drawer.prototype = propTypes;

export default function Drawer(props) {
  const patient = React.useContext(PatientData);
  const [newSupportMessage, setHasNewSupportMessage] = React.useState(false);
  const [fetched, setFetched] = React.useState({ in_progress: false, old: false });
  const [fetching, setFetching] = React.useState({ in_progress: false, old: false });
  const [openFolder, setFolderOpen] = React.useState({
    in_progress: false,
    completed: false,
    new: false,
    old: false,
  });
  const [messagePage, setMessagePage] = React.useState(1);

  React.useEffect(() => {
    if (!!props.support_messages.length > 0) {
      let first = props.support_messages[0];
      if (first.support_agent_id !== null) {
        setHasNewSupportMessage(true);
      }
    }
  }, [props.notifications, props.messages, props.cprs, props.fetching]);

  const fetchMoreOld = async () => {
    const page = messagePage + 1;
    setMessagePage(page);
    setFetching({ ...fetching, old: true });
    let data = await API.getMessages(page);
    if (!!data.messages.length) {
      props.dispatch({ type: "set_more_messages", payload: data });
      setFetching({ ...fetching, old: false });
    }
    if (data.messages == []) {
      !fetched.old && setFetched({ ...fetched, old: true });
      setFetching({ ...fetching, old: false });
    }
  };

  const history = useHistory();
  const styles = useStyles();

  const renderCprMenu = (
    <>
      <ListSubheader className="bt">
        <Box pl={1.5} pt={2.5} fontWeight="300" color="#506d7d">
          Care Plan Requirements
        </Box>
      </ListSubheader>
      <ListItem disablePadding>
        {!!props.notifications.length > 0 ? (
          <ListItemButton
            className="drawer-nav-list-item"
            onClick={(e) => {
              e.preventDefault();
              props.handleDrawerToggle();
              props.dispatch({ type: "set_current_cpr", payload: props.notifications[0] });
              history.push(`/patient_portal/notifications/${props.notifications[0].id}`);
            }}
          >
            <ListItemIcon>
              <Badge badgeContent={props.notifications.length} color="error">
                <MdNotificationsNone />
              </Badge>
            </ListItemIcon>
            <ListItemText primary="Needs Response" />
          </ListItemButton>
        ) : (
          <ListItemButton className="drawer-nav-list-item" disabled>
            <ListItemIcon>
              <MdNotificationsNone />
            </ListItemIcon>
            <ListItemText primary="Needs Response" />
          </ListItemButton>
        )}
      </ListItem>

      {!!props.notifications.length > 0 &&
        props.notifications.map((cpr) => (
          <ListItem disablePadding key={"cpr-needs_attention-" + cpr.id}>
            <ListItemButton
              className="drawer-nav-notification-item"
              sx={{ pl: 1.5, pb: 1, pt: 1 }}
              onClick={(e) => {
                props.dispatch({ type: "set_current_cpr", payload: cpr });
                history.push(`/patient_portal/notifications/${cpr.id}`);
                props.handleDrawerToggle();
              }}
            >
              <ListItemIcon>
                <Badge color="error" variant="dot" />
              </ListItemIcon>
              <ListItemText
                primary={cpr.procedure_type}
                secondary={
                  cpr.date_type == "Appointment Date"
                    ? "Appt Date: " + cpr.date
                    : cpr.date_type + ": " + cpr.date
                }
              />
            </ListItemButton>
          </ListItem>
        ))}
      {props.in_progress.count !== 0 ? (
        <ListSubheader
          sx={{ p: 0 }}
          onClick={(e) => {
            !openFolder.in_progress
              ? setFolderOpen({
                  ...openFolder,
                  in_progress: true,
                })
              : setFolderOpen({
                  ...openFolder,
                  in_progress: false,
                });
          }}
        >
          <ListItemButton>
            <Box fontSize="18px" className="folder" sx={{ pl: 1.5, pr: 1 }}>
              In Progress
            </Box>

            <IconButton
              color="inherit"
              size="large"
              className="nav-button"
              aria-label="open CPR menu in progress"
              edge="end"
            >
              {openFolder["in_progress"] ? <MdExpandLess /> : <MdExpandMore />}
            </IconButton>
          </ListItemButton>
        </ListSubheader>
      ) : (
        <ListSubheader sx={{ p: 0 }}>
          <ListItemButton disabled>
            <Box fontSize="18px" className="folder" sx={{ pl: 1.5, pr: 1 }}>
              In Progress
            </Box>

            <IconButton
              color="inherit"
              size="large"
              className="nav-button"
              aria-label="open CPR menu in progress"
              edge="end"
              disabled
            >
              <MdExpandMore />
            </IconButton>
          </ListItemButton>
        </ListSubheader>
      )}
      <Collapse
        in={openFolder.in_progress}
        timeout="auto"
        unmountOnExit
        className="folder-collapse"
      >
        {props.cprs.map((cpr, idx) => {
          if (!cpr.needs_attention) {
            return (
              <ListItem disablePadding key={"cpr-" + cpr.id} className={styles.responded}>
                <ListItemButton
                  sx={{ pl: 2, pb: 1, pt: 1, pr: 1 }}
                  onClick={(e) => {
                    props.dispatch({ type: "set_current_cpr", payload: cpr });
                    history.push(`/patient_portal/requirement/${cpr.id}`);
                    props.handleDrawerToggle();
                  }}
                >
                  <ListItemText
                    className="light"
                    inset
                    primary={cpr.procedure_type}
                    secondary={
                      cpr.date_type == "Appointment Date"
                        ? "Appt Date: " + cpr.date
                        : cpr.date_type + ": " + cpr.date
                    }
                  />
                </ListItemButton>
              </ListItem>
            );
          }
        })}

        {!props.fetching.in_progress && !props.in_progress.fetched && (
          <Box className={styles.responded}>
            <Box mx={"35%"} py={1.5}>
              <Fab
                sx={{
                  zIndex: 0,
                }}
                className="load-more "
                aria-label="load more CPRs"
                onClick={(e) => {
                  props.fetch.cprs();
                }}
              >
                <FaChevronDown />
              </Fab>
            </Box>
          </Box>
        )}
      </Collapse>

      {props.completed.total !== 0 ? (
        <ListSubheader
          sx={{ p: 0 }}
          onClick={(e) => {
            !openFolder.completed
              ? setFolderOpen({
                  ...openFolder,
                  completed: true,
                })
              : setFolderOpen({
                  ...openFolder,
                  completed: false,
                });
          }}
        >
          <ListItemButton>
            <Box fontSize="18px" className="folder" sx={{ pl: 1.5, pr: 1 }}>
              Completed
            </Box>
            <IconButton
              color="inherit"
              size="large"
              className="nav-button"
              aria-label="open completed CPRs"
              edge="end"
            >
              {openFolder["completed"] ? <MdExpandLess /> : <MdExpandMore />}
            </IconButton>
          </ListItemButton>
        </ListSubheader>
      ) : (
        <ListSubheader sx={{ p: 0 }}>
          <ListItemButton disabled>
            <Box fontSize="18px" className="folder" sx={{ pl: 1.5, pr: 1 }}>
              Completed
            </Box>
            <IconButton
              disabled
              color="inherit"
              size="large"
              className="nav-button"
              aria-label="open completed CPRs"
              edge="end"
            >
              <MdExpandMore />
            </IconButton>
          </ListItemButton>
        </ListSubheader>
      )}

      <Collapse in={openFolder.completed} timeout="auto" unmountOnExit className="folder-collapse">
        {props.completed_cprs.map((cpr, idx) => {
          return (
            <ListItem key={"cpr-" + cpr.id} disablePadding className={styles.responded}>
              <ListItemButton
                sx={{ pl: 2, pb: 1, pt: 1 }}
                onClick={(e) => {
                  history.push(`/patient_portal/requirement/${cpr.id}`);
                  props.dispatch({ type: "set_current_cpr", payload: cpr });
                  props.handleDrawerToggle();
                }}
              >
                <ListItemText
                  inset
                  className="light"
                  primary={cpr.procedure_type}
                  secondary={"Completed: " + cpr.date}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
        {!props.fetching.completed && !props.completed.fetched && (
          <Box className={styles.responded}>
            <Box mx={"35%"} py={1.5}>
              <Fab
                sx={{
                  zIndex: 0,
                }}
                className="load-more "
                aria-label="load more completed"
                onClick={(e) => {
                  props.fetch.completed();
                }}
              >
                <FaChevronDown />
              </Fab>
            </Box>
          </Box>
        )}
      </Collapse>
    </>
  );

  const renderAdditionalMessages = (
    <>
      <ListSubheader className="bt">
        <Box pl={1.5} pt={2.5} pb={1} fontWeight="300" color="#506d7d">
          Additional Messages
        </Box>
      </ListSubheader>
      <ListItem disablePadding>
        {!!props.messages.length > 0 ? (
          <ListItemButton
            className="drawer-nav-list-item"
            onClick={(e) => {
              e.preventDefault();
              history.push(`/patient_portal/additional_messages/${props.messages[0].id}`);
              props.handleDrawerToggle();
            }}
          >
            <ListItemIcon>
              <Badge badgeContent={props.messages.length} color="error">
                <MdOutlineMailOutline />
              </Badge>
            </ListItemIcon>
            <ListItemText primary="Needs Response" />
          </ListItemButton>
        ) : (
          <ListItemButton className="drawer-nav-list-item" disabled>
            <ListItemIcon>
              <MdOutlineMailOutline />
            </ListItemIcon>
            <ListItemText primary="Needs Response" />
          </ListItemButton>
        )}
      </ListItem>

      {!!props.messages.length > 0 &&
        props.messages.map((m, idx) => (
          <ListItem disablePadding key={m.id}>
            <ListItemButton
              className="drawer-nav-notification-item"
              sx={{ pl: 1.5, pb: 1, pt: 1, pr: 1 }}
              onClick={(e) => {
                e.preventDefault();
                props.dispatch({ type: "set_active_message", payload: m });
                history.push(`/patient_portal/additional_messages/${m.id}`);
                props.handleDrawerToggle();
              }}
            >
              <ListItemIcon>
                <Badge color="error" variant="dot" />
              </ListItemIcon>
              <ListItemText primary={m.title} secondary={new Date(m.created_at).toDateString()} />
            </ListItemButton>
          </ListItem>
        ))}

      {!!props.old.length > 0 ? (
        <ListSubheader
          sx={{ p: 0 }}
          onClick={(e) => {
            !openFolder.old
              ? setFolderOpen({ ...openFolder, old: true })
              : setFolderOpen({ ...openFolder, old: false });
          }}
        >
          <ListItemButton>
            <Box fontSize="18px" className="folder" sx={{ pl: 1.5, pr: 1 }}>
              Completed
            </Box>
            <IconButton
              color="inherit"
              size="large"
              className="nav-button"
              aria-label="open old additional notifications"
              edge="end"
            >
              {openFolder["old"] ? <MdExpandLess /> : <MdExpandMore />}
            </IconButton>
          </ListItemButton>
        </ListSubheader>
      ) : (
        <ListSubheader sx={{ p: 0 }}>
          <ListItemButton disabled>
            <Box fontSize="18px" className="folder" sx={{ pl: 1.5, pr: 1 }}>
              Completed
            </Box>
            <IconButton
              disabled
              color="inherit"
              size="large"
              className="nav-button"
              aria-label="open old additional notifications"
              edge="end"
            >
              <MdExpandMore />
            </IconButton>
          </ListItemButton>
        </ListSubheader>
      )}

      <Collapse in={openFolder.old} timeout="auto" unmountOnExit className="folder-collapse">
        {props.old.map((m, idx) => {
          return (
            <ListItem disablePadding key={m.id} className={styles.responded}>
              <ListItemButton
                sx={{ pl: 2, pb: 1, pt: 1, pr: 1 }}
                onClick={(e) => {
                  e.preventDefault();
                  history.push(`/patient_portal/message/${m.id}`);
                  props.handleDrawerToggle();
                }}
              >
                <ListItemText
                  inset
                  className="light"
                  primary={m.title}
                  secondary={"Responded: " + new Date(m.date_responded).toDateString()}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
        {!fetching.old &&
          !fetched.old &&
          props.messages.length + props.old.length < props.messageCount && (
            <Box className={styles.responded}>
              <Box mx={"35%"} py={1.5}>
                <Fab
                  sx={{
                    zIndex: 0,
                  }}
                  className="load-more "
                  aria-label="load more"
                  onClick={(e) => {
                    fetchMoreOld();
                  }}
                >
                  <FaChevronDown />
                </Fab>
              </Box>
            </Box>
          )}

        {fetching.old && (
          <>
            <Box p={2} textAlign="center">
              <CircularProgress />
            </Box>
          </>
        )}
      </Collapse>
    </>
  );

  const renderMainMenuRoutes = [
    { name: "Dashboard", route: "/patient_portal/dashboard", icon: <MdHome /> },
    {
      name: "Info Center",
      route:
        patient.onboarding_step !== patient.patient_info_modules?.length
          ? "/patient_portal/onboarding"
          : "/patient_portal/info_center",
      icon: <BiBookHeart />,
    },
    {
      name: "General Support",
      route: "/patient_portal/general_support",
      icon: <MdSupportAgent />,
      alert: newSupportMessage,
      alertCount: 1
    },
    {
      name: patient.health_plan_awv_program_name,
      route: "/patient_portal/annual_wellness_visit",
      show: patient.show_awv_page,
      icon: <LocalHospitalIcon />,
    },

    {
      name: "Specialist Referrals",
      route: "/patient_portal/specialist_referrals",
      icon: <FeedIcon />,
      show: patient.show_specialist_referrals_app,
      alert: patient.specialist_referrals_count > 0,
      alertCount: patient.specialist_referrals_count
    },
  ].map((r, idx) => {
    if (r.show == false) {
      return (<div key={idx}>

      </div>);
    } else {
      return (
        <ListItem disablePadding key={idx}>
          <ListItemButton
            className="drawer-nav-list-item"
            onClick={(e) => {
              e.preventDefault();
              props.handleDrawerToggle();
              history.push(r.route);
            }}
          >
            <ListItemIcon>
              {r.alert == true && r.alertCount > 0 ? (
                <Badge color="error" badgeContent={r.alertCount}>
                  {r.icon}
                </Badge>
              ) : (
                r.icon
              )}
            </ListItemIcon>
            <ListItemText primary={r.name} />
          </ListItemButton>
        </ListItem>
      );
    }
  });

  return (
    <List
      sx={{
        p: 0,
        position: "relative",
        width: "100%",
        "&ul": { padding: 0 },
      }}
      subheader={renderMainMenuRoutes}
    >
      {renderCprMenu}
      {renderAdditionalMessages}
    </List>
  );
}
